import { EChartsOption } from "echarts";
import { IChartData } from "src/app/models/api/dashboards.model";

export const createChartSetup = (chartData: IChartData[]): EChartsOption => ({
    textStyle: {
        fontFamily: "Basis Grotesque Pro",
        color: "#000000",
    },
    tooltip: {
        trigger: "item",
    },
    series: [
        {
            right: "20%",
            left: "20%",
            bottom: "10%",
            type: "pie",
            radius: ["65%", "80%%"],
            label: {
                color: "#000000",
                fontSize: "16",
                position: "center",
                fontWeight: "bold",
                fontFamily: "Basis Grotesque Pro",
                formatter: () => `Total\n${chartData.sumBy((series) => series.value)}`,
            },

            labelLine: {
                show: false,
            },
            avoidLabelOverlap: false,
            data: chartData,
            cursor: "pointer",
        },
    ],
    legend: {
        bottom: "5%",
        orient: "horizontal",

        itemGap: 20,
        icon: "circle",
        textStyle: {
            fontSize: 12,
            fontWeight: 500,
            color: "#000000",
        },
    },
});
